export default __webpack_public_path__ + "images/bdebf696806c4c5987ba82acb513594b-unaffiliated_small.webp";